import { useEffect } from 'react'
import MXExchange from '../MXExchange/MXExchange'

const MXWatchlist = (props) => {
  useEffect(() => {
    props.setCurrentTab('watchlist')
    if (!props.is_admin) {
      props.setSelectedCommodity()
      props.setSelectedCommodityForm()
    }
  }, [])

  return (
    <MXExchange
      currentSelectedLocation={props.currentSelectedLocation}
      setCurrentSelectedLocation={props.setCurrentSelectedLocation}
      loadData={props?.loadData}
      watchlist={true}
      business={props.business}
      openExchangeFilter={props.openExchangeFilter}
      setOpenExchangeFilter={props.setOpenExchangeFilter}
      user={props.user}
      setUser={props.setUser}
      setAdminUser={props.setAdminUser}
      reload={props.reload}
      setReload={props.setReload}
      is_admin={props.is_admin}
      currentPortal={props.currentPortal}
      setCurrentPortal={props.setCurrentPortal}
      selectedCommodity={props.selectedCommodity}
      setSelectedCommodity={props.setSelectedCommodity}
      openStartListingModal={props.openStartListingModal}
      inputExpiration={props.inputExpiration}
      setInputExpiration={props.setInputExpiration}
      setInputSecondaryPrice={props.setInputSecondaryPrice}
      inputSecondaryPrice={props.inputSecondaryPrice}
      setStartListingModal={props.setStartListingModal}
      openSetAttributesModal={props.openSetAttributesModal}
      setOpenAttributesModal={props.setOpenAttributesModal}
      openPricingModal={props.openPricingModal}
      setOpenPricingModal={props.setOpenPricingModal}
      setReloadHeaderStats={props.setReloadHeaderStats}
      openReviewListingModal={props.openReviewListingModal}
      setReviewListingModal={props.setReviewListingModal}
      hideFilter={props.hideFilter}
      setHideFilter={props.setHideFilter}
      productVariant={props.productVariant}
      setProductVariant={props.setProductVariant}
      setInputPrice={props.setInputPrice}
      inputPrice={props.inputPrice}
      setInputQuantity={props.setInputQuantity}
      inputQuantity={props.inputQuantity}
      setCurrentTab={props.setCurrentTab}
      currentTab={props.currentTab}
      equipmentType={props.equipmentType}
      setEquipmentType={props.setEquipmentType}
      setSelectedCommodityForm={props.setSelectedCommodityForm}
      currentlySelectedTimeframe={props.currentlySelectedTimeframe}
      setCurrentlySelectedTimeframe={props.setCurrentlySelectedTimeframe}
      currentlySelectedTruckingType={props.currentlySelectedTruckingType}
      setCurrentlySelectedTruckingType={props.setCurrentlySelectedTruckingType}
    />
  )
}

export default MXWatchlist
